/* eslint-disable function-paren-newline */

// See React on Rails Pro documentation for details regarding **.imports-X.** file extension & duplicate file structure.
import loadable from '@loadable/component';
import retry from '../../../utils/retry';

export const SearchMap = loadable(() => retry(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: "SearchMap" */
  './SearchMap')));
